import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withKeys as _withKeys, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40958546"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" If you forgot your password, please use our helpdesk to contact us. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://helpdesk.steiner.cz/index.php",
    target: "_blank",
    rel: "noopener noreferrer"
  }, " https://helpdesk.steiner.cz/index.php "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Log in, click on the tab “Requests”, then on the tab “Insert request”. Fill out the fields marked with a red asterisk and then press “Submit ticket”. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" If you do not have a helpdesk account, contact us at "),
  /*#__PURE__*/_createElementVNode("a", { href: "mailto:atlantaadm@steiner.cz" }, " atlantaadm@steiner.cz "),
  /*#__PURE__*/_createTextVNode(" and we can help you with creating a new account” ")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Please check the authenticity and validity of application/server certificate before you login to prevent the Man-in-the-Middle attacks. ")
const _hoisted_3 = { style: {"width":"400px","margin":"auto"} }
const _hoisted_4 = {
  key: 0,
  class: "Donor"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<label class=\"Donor\" data-v-40958546> Atlanta <span style=\"float:right;\" data-v-40958546>TC web</span></label><label class=\"Donor\" for=\"select\" data-v-40958546>Registry</label><select class=\"Donor\" id=\"select\" name=\"select\" data-v-40958546><option class=\"Donor\" value=\"1\" selected=\"true\" data-v-40958546>Finland</option></select><label class=\"Donor\" data-v-40958546>E-mail</label>", 4)
const _hoisted_9 = {
  key: 0,
  id: "username-help",
  class: "p-error"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "Donor" }, "Password", -1))
const _hoisted_11 = {
  key: 1,
  id: "password-help",
  class: "p-error"
}
const _hoisted_12 = {
  key: 1,
  class: "Donor"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "Donor" }, "Authentification code", -1))
const _hoisted_14 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Two Factor Authentication/MFA", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"max-width":"1000px"} }, " We use TOTP (Time-based One Time Password) technologies for two-factor authentication. Using the button below you can generate a QR code, which you can scan and open in your phone's TOTP supported application. After generating the security QR code, you'll be prompted to enter the verification code every time you log in. The supported applications are listed below, but many authenticator apps work the same, should you choose to use your own preferred application ", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<br data-v-40958546> App Store: <ul data-v-40958546><li id=\"iOS-Google\" data-v-40958546><a href=\"https://apps.apple.com/cz/app/google-authenticator/id388497605\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-40958546> Google Authenticator </a></li><li id=\"iOS-Microsoft\" data-v-40958546><a href=\"https://apps.apple.com/cz/app/microsoft-authenticator/id983156458\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-40958546> Microsoft Authenticator </a></li></ul> Google Play: <ul data-v-40958546><li id=\"Android-Google\" data-v-40958546><a href=\"https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-40958546> Google Authenticator </a></li><li id=\"Android-Microsoft\" data-v-40958546><a href=\"https://play.google.com/store/apps/details?id=com.azure.authenticator\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-40958546> Microsoft Authenticator </a></li></ul>", 5)
const _hoisted_25 = {
  key: 3,
  id: "two-fac-help",
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Message = _resolveComponent("Message")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_InputMask = _resolveComponent("InputMask")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      header: "Forgot password",
      visible: _ctx.forgotPasswordDialog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.forgotPasswordDialog) = $event)),
      modal: true
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Message, { severity: "info" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    (_ctx.error)
      ? (_openBlock(), _createBlock(_component_Message, {
          key: 0,
          severity: "error"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.error), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "",
      onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args)), ["enter"]))
    }, [
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.showCode)
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                type: "text",
                size: "20",
                id: "email",
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                placeholder: "Email..",
                class: _normalizeClass(["Donor nofill", { 'p-invalid': !_ctx.isEmail }])
              }, null, 8, ["modelValue", "class"]),
              (!_ctx.isEmail)
                ? (_openBlock(), _createElementBlock("small", _hoisted_9, " Please fill valid email. "))
                : _createCommentVNode("", true),
              _hoisted_10,
              _createVNode(_component_InputText, {
                type: "password",
                size: "20",
                id: "password",
                modelValue: _ctx.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                placeholder: "Password..",
                class: _normalizeClass(["Donor nofill", { 'p-invalid': !_ctx.isPassword }])
              }, null, 8, ["modelValue", "class"]),
              (!_ctx.isEmail)
                ? (_openBlock(), _createElementBlock("small", _hoisted_11, " Please fill password. "))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                label: "Sign in",
                class: "logInButton",
                disabled: !_ctx.isPassword || !_ctx.isEmail,
                onclick: _ctx.login
              }, null, 8, ["disabled", "onclick"]),
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.forgotPasswordDialog = true)),
                style: {"margin-top":"10px","color":"#2196f3","cursor":"pointer"}
              }, " Forgot password? ")
            ]))
          : _createCommentVNode("", true),
        (_ctx.showCode)
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_12, [
              _hoisted_13,
              _createVNode(_component_SelectButton, {
                modelValue: _ctx.selectedCodeType,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCodeType) = $event)),
                options: _ctx.allowedCodes,
                optionLabel: "name",
                optionValue: "code"
              }, null, 8, ["modelValue", "options"]),
              (!_ctx.allowedCodes.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No option enabled "))
                : _createCommentVNode("", true),
              ((_ctx.setTOTP || _ctx.googleAuthImage) && _ctx.selectedCodeType == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createVNode(_component_Button, {
                      label: "Generate QR",
                      onClick: _ctx.googleAuth,
                      disabled: !_ctx.setTOTP
                    }, null, 8, ["onClick", "disabled"]),
                    _hoisted_18,
                    (_ctx.googleAuthImage)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: 'data:image/jpeg;base64, ' + _ctx.googleAuthImage,
                          alt: "Alt"
                        }, null, 8, _hoisted_19))
                      : _createCommentVNode("", true),
                    _hoisted_20
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedCodeType >= 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    label: _ctx.codeButtonLabel,
                    class: "logInButton",
                    onclick: _ctx.sendCode,
                    disabled: 
            _ctx.codeDisableSend || (_ctx.setTOTP && _ctx.selectedCodeType == 0)
          
                  }, null, 8, ["label", "onclick", "disabled"]))
                : _createCommentVNode("", true),
              _createElementVNode("p", null, _toDisplayString(_ctx.codeHintLabel), 1),
              _createVNode(_component_InputMask, {
                id: "code",
                ref: "codeInput",
                modelValue: _ctx.code,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.code) = $event)),
                slotChar: "-",
                class: _normalizeClass(["Donor nofill", { 'p-invalid': _ctx.wrongCode }]),
                mask: "999 999",
                unmask: "",
                disabled: !_ctx.codeSent
              }, null, 8, ["modelValue", "class", "disabled"]),
              (_ctx.wrongCode)
                ? (_openBlock(), _createElementBlock("small", _hoisted_25, " Invalid Code try again "))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                label: "Verify code",
                class: "logInButton",
                onclick: _ctx.sign,
                disabled: _ctx.selectedCodeType < 0 || !_ctx.code || !_ctx.codeSent
              }, null, 8, ["onclick", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ], 32)
  ], 64))
}